import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { getPayvantageUrl } from "../lib/api";

export default function ApplyButton({ label = "Apply for Payvantage Leasing", className = "", testId = "apply-payvantage-btn" }) {
  const [url, setUrl] = useState("#");
  useEffect(() => {
    getPayvantageUrl().then(setUrl);
  }, []);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`group inline-flex items-center gap-2 rounded-full bg-crimson px-8 py-4 text-base font-bold text-white transition-colors duration-300 hover:bg-crimson-hover ${className}`}
    >
      {label}
      <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
}
